import Vue from 'vue'

const state = Vue.observable({
  visible: false,
  percent: 0,
  status: 'uploading',
  fileName: '',
  token: 0,
})

let hideTimer = null

function clearHideTimer() {
  if (!hideTimer) {
    return
  }
  clearTimeout(hideTimer)
  hideTimer = null
}

function start(fileName) {
  clearHideTimer()
  state.visible = true
  state.percent = 0
  state.status = 'uploading'
  state.fileName = fileName || '正在上传文件'
  state.token += 1
  return state.token
}

function update(percent, token) {
  if (token && token !== state.token) {
    return
  }
  const value = Number(percent)
  state.percent = Math.max(0, Math.min(100, Math.round(Number.isFinite(value) ? value : 0)))
}

function finish(success, token, fileName) {
  if (token && token !== state.token) {
    return
  }
  clearHideTimer()
  state.status = success ? 'success' : 'exception'
  state.percent = success ? 100 : state.percent
  if (fileName) {
    state.fileName = fileName
  }
  hideTimer = setTimeout(() => {
    if (token && token !== state.token) {
      return
    }
    state.visible = false
    state.percent = 0
    state.status = 'uploading'
    state.fileName = ''
  }, success ? 1000 : 1800)
}

export default {
  state,
  start,
  update,
  finish,
}



// WEBPACK FOOTER //
// ./src/utils/uploadProgress.js